document.addEventListener("DOMContentLoaded", () => {
    const inputsProduct = Array.from(document.querySelectorAll(".swatchInput"));

    const inputYes = inputsProduct.find(input => String(input.value).toUpperCase() === "YES");
    const inputNo = inputsProduct.find(input => String(input.value).toUpperCase() === "NO");

    const boxPersonalizacao = document.getElementById("aparecer");
    const nomeCamisa = document.getElementById("nomecamisa");
    const numCamisa = document.getElementById("numcamisa");

    if (!boxPersonalizacao || !nomeCamisa || !numCamisa) {
        return;
    }

    function ativarPersonalizacao() {
        boxPersonalizacao.style.display = "block";

        nomeCamisa.disabled = false;
        numCamisa.disabled = false;

        nomeCamisa.required = true;
        numCamisa.required = true;
    }

    function desativarPersonalizacao() {
        boxPersonalizacao.style.display = "none";

        nomeCamisa.value = "";
        numCamisa.value = "";

        nomeCamisa.required = false;
        numCamisa.required = false;

        nomeCamisa.disabled = true;
        numCamisa.disabled = true;
    }

    function verificarVarianteSelecionada() {
        if (inputYes && inputYes.checked) {
            ativarPersonalizacao();
        } else {
            desativarPersonalizacao();
        }
    }

    inputsProduct.forEach(input => {
        input.addEventListener("change", verificarVarianteSelecionada);
    });

    const productForms = document.querySelectorAll('form[action*="/cart/add"]');

    productForms.forEach(form => {
        form.addEventListener("submit", () => {
            if (!inputYes || !inputYes.checked) {
                desativarPersonalizacao();
            }
        });
    });

    verificarVarianteSelecionada();
});